/**
 * Shared display constants for the Cube module. Centralising these seeds a
 * single source of truth (and a future i18n boundary) for the labels and
 * formats used across the quote/schedule views.
 */

/** Date format for schedule / quote phase dates, e.g. "15 Mar 2026". */
export const phaseDateFormat = 'd MMM yyyy'

/**
 * User-facing labels for the special end-date states a billing schedule can be
 * in. Mirrors the strings produced by `formatScheduleEndDate` so the module and
 * the shared util stay consistent.
 */
export const scheduleLabels = {
  openEnded: 'Open ended',
  milestone: 'Milestone based'
} as const
